import SpecialtyAccountApplicationForms from './SpecialtyAccountApplicationForms';

export default SpecialtyAccountApplicationForms;
